import { render, staticRenderFns } from "./EnergyСonsumption.vue?vue&type=template&id=edd9280e&scoped=true&"
import script from "./EnergyСonsumption.vue?vue&type=script&lang=js&"
export * from "./EnergyСonsumption.vue?vue&type=script&lang=js&"
import style0 from "./EnergyСonsumption.vue?vue&type=style&index=0&id=edd9280e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9280e",
  null
  
)

export default component.exports